import { root } from 'elc-universal-utils';

export const getQueryParams = () => {
    return (<Location>root.location).search;
};
